export const parentNavigate = (path) => {
  window.parent.postMessage(
    {
      action: "navigateToHome",
      url: path,
    },
    "*"
  );
};
